// import { people01, people02, people03, facebook, instagram, linkedin, twitter, airbnb, binance, coinbase, dropbox, send, shield, star  } from "../assets";

import picOne from '../img/pic1.jpg'
import picTwo from '../img/pic2.jpg'
import picThree from '../img/KITFOO.png'
import picFour from '../img/ck.jpg'
import picFive from '../img/foul_Br.jpg'
import picSix from '../img/goredGOred.jpg'
import derekTibs from '../img/derekTibs.jpg'
import gather from '../img/gather.jpg'
import store from '../img/store.jpg'
import pic1 from '../img/1.jpg'
import pic2 from '../img/2.jpg'
import pic3 from '../img/3.jpg'
import pic4 from '../img/4.jpg'
import vegvegieCombo from '../img/vegieCombo.png'

export const navLinks = [
  {
    id: "home",
    title: "Home",
  },
  {
    id: "Menu",
    title: "Menu",
  },
  {
    id: "Book a Table",
    title: "Book a Table",
  },
  {
    id: "Online Ordering",
    title: "Online Ordering",
  },
  {
    id: "About",
    title: "About",
  },
  {
    id: "Hours & Locations",
    title: "Hours & Locations",
  },
  {
    id: "Shop",
    title: "Shop",
  },

  // {
  //   id: "features",
  //   title: "Features",
  // },
  // {
  //   id: "product",
  //   title: "Product",
  // },
  // {
  //   id: "clients",
  //   title: "Clients",
  // },
];

export const leftShoppingLink = [{
  id: 1,
  links: 'All Products'
},
{
  id: 2,
  links: 'spices'
},
{
  id: 3,
  links: 'cloths'
},
{
  id: 4,
  links: 'grocery'
},

]

// export const features = [
//   {
//     id: "feature-1",
//     icon: star,
//     title: "Rewards",
//     content:
//       "The best credit cards offer some tantalizing combinations of promotions and prizes",
//   },
//   {
//     id: "feature-2",
//     icon: shield,
//     title: "100% Secured",
//     content:
//       "We take proactive steps make sure your information and transactions are secure.",
//   },
//   {
//     id: "feature-3",
//     icon: send,
//     title: "Balance Transfer",
//     content:
//       "A balance transfer credit card can save you a lot of money in interest charges.",
//   },
// ];

// export const feedback = [
//   {
//     id: "feedback-1",
//     content:
//       "Money is only a tool. It will take you wherever you wish, but it will not replace you as the driver.",
//     name: "Herman Jensen",
//     title: "Founder & Leader",
//     img: people01,
//   },
//   {
//     id: "feedback-2",
//     content:
//       "Money makes your life easier. If you're lucky to have it, you're lucky.",
//     name: "Steve Mark",
//     title: "Founder & Leader",
//     img: people02,
//   },
//   {
//     id: "feedback-3",
//     content:
//       "It is usually people in the money business, finance, and international trade that are really rich.",
//     name: "Kenn Gallagher",
//     title: "Founder & Leader",
//     img: people03,
//   },
// ];

export const about = [
  {
    id: 1,
    section: "Our Fans'Favorite.",
    title: "kitfo Special ክትፎ ስፔሻል",
    description: "It is Ethiopian Special Kitfo mixed with Homemade Cottage Cheese, Harbor Butter, Mitmita, Cardamom and more ( It can be ordered Raw, Medium or Well Done).",
    links: "#",
    pics: derekTibs
  },
  {
    id: 2,
    section: "Join us",
    title: "Gather around the Table with Our Family Bundle",
    description: "Our Café is the place where you can find different Ethiopian Posters that reflects our traditional history. We serve delicious drinks, hot and cold. We welcome all to come enjoy our great Mart and Café. We also offer you T-Shirts, Jewelries, Gifts and more...",
    links: "#",
    pics: gather
  },
  {
    id: 3,
    section: "Our Store",
    title: "Ethiopian & East African Spices ቅመማ ቅመሞች",
    description: "Looking for more North African Spices? Check out our Foods Market. Most of the spices used in Ethiopian cooking are available in our place. We sell Teff, Berbere, Shiro and a combination of more than 20 spices...",
    links: "#",
    pics: store
  }
];

export const HeroLinks = [
  {
    id: 1,
    title: "Our Menu",
    links: "/Menu",
  },
  {
    id: 2,
    title: "Delivery & Pick UP",
    links: "/OnlineOrdering",
  },
  {
    id: 3,
    title: "Reserve a Table",
    links: "/BookaTable",
  }
];

export const footerLinks = [
  {
    title: "Quick Links",
    links: [
      {
        name: "Menu",
        link: "Menu",
      },
      {
        name: "Book a Table",
        link: "BookaTable",
      },
      {
        name: "Order Online",
        link: "OnlineOrdering",
      },
      {
        name: "Megenagna EQUB CLUB",
        link: "Home",
      }

    ],
  },
  {
    title: "Contact",
    links: [
      {
        name: "Help Center",
        link: "About",
      },
      {
        name: 'Hours & Locations',
        link: "HoursLocations",
      },
      {
        name: "Careers",
        link: "About",
      },

      {
        name: "About",
        link: "About",
      },

    ],
  },
  {
    title: "Follow Us",
    links: [
      {
        name: "twitter",
        link: "mantenance",
      },
      {
        name: "Facebook",
        link: "mantenance",
      },
      {
        name: "Instagram",
        link: "mantenance",
      },
      {
        name: "Telegram",
        link: "mantenance",
      }
    ],
  },
];


// export const socialMedia = [
//   {
//     id: "social-media-1",
//     icon: instagram,
//     link: "https://www.instagram.com/",
//   },
//   {
//     id: "social-media-2",
//     icon: facebook,
//     link: "https://www.facebook.com/",
//   },
//   {
//     id: "social-media-3",
//     icon: twitter,
//     link: "https://www.twitter.com/",
//   },
//   {
//     id: "social-media-4",
//     icon: linkedin,
//     link: "https://www.linkedin.com/",
//   },
// ];

// export const clients = [
//   {
//     id: "client-1",
//     logo: airbnb,
//   },
//   {
//     id: "client-2",
//     logo: binance,
//   },
//   {
//     id: "client-3",
//     logo: coinbase,
//   },
//   {
//     id: "client-4",
//     logo: dropbox,
//   },
// ];


export const moments = [

  {
    title: "Tire Siga",
    description: "Thick strips of raw meat, most often a cow, served with a fiery spice blend(mitmita) and a small bowl of a runny, spicy mustard sauce(senafich) and injera,",
    links: picOne,
    stars: 4,
    timeToCooke: '20 min'
  },
  {
    title: "Shekla Tibs",
    description: "Fried, dry tibs called shekla tibs, served sizzling with awaze to dip, injera, and bread.",
    links: picTwo,
    stars: 5,
    timeToCooke: '40 min'
  },
  {
    title: "Kitfo Special",
    description: "Lean ground beef seasoned with cardamom, spicy chili powder and Ethiopian Herbal Butter. Served with Ethiopian cottage cheese (Ayib) and collard greens (Gomen). Request Rare, Medium Rare or Well-Done.",
    links: picThree,
    stars: 4,
    timeToCooke: '10 min'
  },
  {
    title: "Foul Special",
    description: "Seasoned beans sautéed with onions, tomatoes, and jalapeño. Topped with ayib ",
    links: picFive,
    stars: 4,
    timeToCooke: '30 min'
  },
  {
    title: "Gored Gored",
    description: "Lean beef cubes mixed with mitmita, awaze, onions and peppers. Rare, medium rare or well done.",
    links: picSix,
    stars: 5,
    timeToCooke: '40 min'
  },
  {
    title: "Vegie Combo",
    description: "Includes five vegetarian items and salad split lentil sauce, yellow peas sauce, col lard green, salad, Cabbage sauce, potato, and carrot sauce.",
    links: vegvegieCombo,
    stars: 5,
    timeToCooke: '25 min'
  },
]

export const MenuTypes = [
  {
    id: 1,
    title: "Breakfast",
    links: "#",
    dbname: "Breakfast",
    servingTime: '9:00am to 11:00am',
    // foodTypes: [
    //   {
    //     id: 1,
    //     type: "Enqulal Ferfer እንቁላል ፍርፍር",
    //     links: "#",
    //     description: 'Style scrambled egg with Tomato, onion, and green paper and other spices cooked together. served with enjere or bread served in your choice',
    //     price: 9.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 2,
    //     type: "Quanta Ferfer ቋንጣ ፍርፍር",
    //     links: "#",
    //     description: 'Dried Beef in Berbere sauce and other spices mixed with Injera served on Ethiopian Injera( Flat Bread)',
    //     price: 10.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 3,
    //     type: "Injera Ferfer እንጀራ ፍርፍር",
    //     links: "#",
    //     description: 'Ethiopian bread እንጀራ mixed with onion tomatoes green pepper tossed in berbere (red pepper) sauce',
    //     price: 10.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 4,
    //     type: "Kinche ቅንጬ",
    //     links: "#",
    //     description: 'Cracked wheat served with Ethiopian Metemeta and other spices',
    //     price: 14.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 5,
    //     type: "Foul Special ፉል ስቴሻል",
    //     links: "#",
    //     description: 'Specially cooked beans served mix with red onions, fresh green pepper, fresh ricotta cheese, fried egg and olive oil served with bread',
    //     price: 14.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 6,
    //     type: "SCRAMBLED EGG WITH MEAT እንቁላል ፍርፍር በስጋ",
    //     links: "#",
    //     description: 'Scrambled egg with meat, tomato, onion, and green pepper and other spices cooked together, served with injera or bread',
    //     price: 11.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 7,
    //     type: "Tegabino ተጋቢኖ",
    //     links: "#",
    //     description: 'Roasted and powdered peas are simmered with red onion, vegetable oil, garlic, ginger, and spicy red pepper',
    //     price: 10.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 8,
    //     type: "Ful Special ፉል ስፔሻል",
    //     links: "#",
    //     description: 'Specially Cooked cave beans served mix with Red Onions, Fresh Green Paper, Fresh Ricotta Cheese, Boiled Egg and Olive Oil served with bread.',
    //     price: 9.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 9,
    //     type: "Chechebsa",
    //     links: "#",
    //     description: 'Specially mixed small pieces of fried flatbread, spiced with buttered powdered red pepper',
    //     price: 12.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    // ]

  },
  {
    id: 2,
    title: "Lunch & Dinner Menu",
    links: "#",
    dbname: "lunch&Dinner",
    servingTime: '11:00am to 9:00pm',
    // foodTypes: [
    //   {
    //     id: 1,
    //     type: "Awaze Tibs አዋዜ ጥብስ",
    //     links: "#",
    //     description: 'Tender, marinated pieces of beef, cooked with green pepper, onion, garlic, tomato, a touch of rosemary, and other spices, served on Ethiopian bread እንጀራ',
    //     price: 14.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 2,
    //     type: "Kitfo Special ክትፎ ስፔሻል",
    //     links: "#",
    //     description: 'It is Ethiopian Special kitfo mixed with homemade cottage cheese, Herbal butter cardamom, mitmita and more (It can be ordered Raw,Medium or Well Done)',
    //     price: 16.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 3,
    //     type: "Gaslight Tibs ጋዝላይት ጥብስ",
    //     links: "#",
    //     description: 'Raw meat cooked with coriander powder, rosemary powder, onions, jalapeño, ground ginger, black pepper, garlic powder, and oregano',
    //     price: 13.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 4,
    //     type: "Kinche ቅንጬ",
    //     links: "#",
    //     description: 'Cracked wheat served with Ethiopian Metemeta and other spices',
    //     price: 14.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 5,
    //     type: "Kikel ቅቅል",
    //     links: "#",
    //     description: 'Pieces of Beef with bones cooked in mild green paper and turmeric sauce, seasoned with onions, garlic herbs and spices',
    //     price: 14.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 6,
    //     type: "Gored Gored ጎረድ ጎረድ",
    //     links: "#",
    //     description: 'Chunked Cubed Beef mixed with Mitmita,Cardamom, and Ethiopian Butter(It can be ordered Raw, Medium, or Well done)',
    //     price: 15.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 7,
    //     type: "Yebeg Tibs የበግ ጥብስ",
    //     links: "#",
    //     description: 'Tender, Marinated pieces of sheep Cooked with Green Peppers, Onions, Garlic, Tomato a touch Of Rosemary and other Spices served on Ethiopian Injera (Flat Bread)',
    //     price: 14.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 8,
    //     type: "Kitfo Special ክትፎ ስቴሻል",
    //     links: "#",
    //     description: 'Steak tartare from selected lean round steak, seasoned with purified and herbed butter sauce and hot spiced chilled powder (mitmita)',
    //     price: 12.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 9,
    //     type: "Derrek Tibs ደረቀ ጥብስ",
    //     links: "#",
    //     description: 'Cubed tender beef cooked with onions, green pepper and rosemary served with enjera and awazie sauce',
    //     price: 14.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 10,
    //     type: "Tibs Ferfer ጥብስ ፍርፍር",
    //     links: "#",
    //     description: 'Cubed tender beef specially prepared enjera with tomato cooked with onions, green salsa, onion, and garlic cooked in your choice of Ethopian butter or oil',
    //     price: 14.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 11,
    //     type: "kitfo Normal ክትፎ ኖርማል",
    //     links: "#",
    //     description: 'Beef Tartar seasoned with Harbor butter and Mitmita, Cardamom (It can be ordered Raw, Medium or Well Done)',
    //     price: 12.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 12,
    //     type: "Quanta Ferfir ቋንጣ ፍርፍር",
    //     links: "#",
    //     description: 'Ethiopian bread እንጀራ mixed with beef jerky, tomato, onion, and pepper, cooked with spices, and served with boiled egg, and soft injera or bread',
    //     price: 14.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 13,
    //     type: "Goden Tibs",
    //     links: "#",
    //     description: 'Sizzling prime short ribs marinated with Habesha sauce',
    //     price: 15.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },
    //   {
    //     id: 14,
    //     type: "Chickpeas",
    //     links: "#",
    //     description: 'Roasted and powdered peas are simmered with red onion, vegetable oil, garlic, ginger, and spicy red pepper',
    //     price: 10.99,
    //     stars: 5,
    //     timeToCooke: '25 min',
    //   },

    // ]

  },
  {
    id: 3,
    title: "Vegetarian",
    dbname: "vegetarian",
    links: "#",
    servingTime: '9:00am to 11:00am',
    // foodTypes: [
    //   {
    //     id: 1,
    //     type: "Enqulal Ferfer እንቁላል ፍርፍር",
    //     links: "#",
    //     description: 'Style scrambled egg with Tomato, onion, and green paper and other spices cooked together. served with enjere or bread served in your choice'
    //   },
    //   {
    //     id: 2,
    //     type: "Quanta Ferfer ቋንጣ ፍርፍር",
    //     links: "#",
    //     description: 'Dried Beef in Berbere sauce and other spices mixed with Injera served on Ethiopian Injera( Flat Bread)',
    //     price: 10.99
    //   },
    //   {
    //     id: 3,
    //     type: "Injera Ferfer እንጀራ ፍርፍር",
    //     links: "#",
    //     description: 'Ethiopian bread እንጀራ mixed with onion tomatoes green pepper tossed in berbere (red pepper) sauce',
    //     price: 10.99,
    //   },
    //   {
    //     id: 4,
    //     type: "Kinche ቅንጬ",
    //     links: "#",
    //     description: 'Cracked wheat served with Ethiopian Metemeta and other spices',
    //     price: 14.99,
    //   },
    //   {
    //     id: 5,
    //     type: "Foul Special ፉል ስቴሻል",
    //     links: "#",
    //     description: 'Specially cooked beans served mix with red onions, fresh green pepper, fresh ricotta cheese, fried egg and olive oil served with bread',
    //     price: 14.99,
    //   },
    //   {
    //     id: 6,
    //     type: "SCRAMBLED EGG WITH MEAT እንቁላል ፍርፍር በስጋ",
    //     links: "#",
    //     description: 'Scrambled egg with meat, tomato, onion, and green pepper and other spices cooked together, served with injera or bread',
    //     price: 11.99,
    //   },
    //   {
    //     id: 7,
    //     type: "Tegabino ተጋቢኖ",
    //     links: "#",
    //     description: 'Roasted and powdered peas are simmered with red onion, vegetable oil, garlic, ginger, and spicy red pepper',
    //     price: 10.99,
    //   },
    //   {
    //     id: 8,
    //     type: "Ful Special ፉል ስፔሻል",
    //     links: "#",
    //     description: 'Specially Cooked cave beans served mix with Red Onions, Fresh Green Paper, Fresh Ricotta Cheese, Boiled Egg and Olive Oil served with bread.',
    //     price: 9.99,
    //   },
    //   {
    //     id: 9,
    //     type: "Chechebsa",
    //     links: "#",
    //     description: 'Specially mixed small pieces of fried flatbread, spiced with buttered powdered red pepper',
    //     price: 12.99,
    //   },
    // ]
  }
  ,
  {
    id: 4,
    title: "Drinks",
    links: "#",
    dbname: "Drinks",
    servingTime: '9:00am to 11:00am',
    // foodTypes: [
    //   {
    //     id: 1,
    //     type: "Enqulal Ferfer እንቁላል ፍርፍር",
    //     links: "#",
    //     description: 'Style scrambled egg with Tomato, onion, and green paper and other spices cooked together. served with enjere or bread served in your choice',
    //     price: 8.99
    //   },
    //   {
    //     id: 2,
    //     type: "Quanta Ferfer ቋንጣ ፍርፍር",
    //     links: "#",
    //     description: 'Dried Beef in Berbere sauce and other spices mixed with Injera served on Ethiopian Injera( Flat Bread)',
    //     price: 10.99
    //   },
    //   {
    //     id: 3,
    //     type: "Injera Ferfer እንጀራ ፍርፍር",
    //     links: "#",
    //     description: 'Ethiopian bread እንጀራ mixed with onion tomatoes green pepper tossed in berbere (red pepper) sauce',
    //     price: 10.99,
    //   },
    //   {
    //     id: 4,
    //     type: "Kinche ቅንጬ",
    //     links: "#",
    //     description: 'Cracked wheat served with Ethiopian Metemeta and other spices',
    //     price: 14.99,
    //   },
    //   {
    //     id: 5,
    //     type: "Foul Special ፉል ስቴሻል",
    //     links: "#",
    //     description: 'Specially cooked beans served mix with red onions, fresh green pepper, fresh ricotta cheese, fried egg and olive oil served with bread',
    //     price: 14.99,
    //   },
    //   {
    //     id: 6,
    //     type: "SCRAMBLED EGG WITH MEAT እንቁላል ፍርፍር በስጋ",
    //     links: "#",
    //     description: 'Scrambled egg with meat, tomato, onion, and green pepper and other spices cooked together, served with injera or bread',
    //     price: 11.99,
    //   },
    //   {
    //     id: 7,
    //     type: "Tegabino ተጋቢኖ",
    //     links: "#",
    //     description: 'Roasted and powdered peas are simmered with red onion, vegetable oil, garlic, ginger, and spicy red pepper',
    //     price: 10.99,
    //   },
    //   {
    //     id: 8,
    //     type: "Ful Special ፉል ስፔሻል",
    //     links: "#",
    //     description: 'Specially Cooked cave beans served mix with Red Onions, Fresh Green Paper, Fresh Ricotta Cheese, Boiled Egg and Olive Oil served with bread.',
    //     price: 9.99,
    //   },
    //   {
    //     id: 9,
    //     type: "Chechebsa",
    //     links: "#",
    //     description: 'Specially mixed small pieces of fried flatbread, spiced with buttered powdered red pepper',
    //     price: 12.99,
    //   },
    // ]
  }
];

export const AllProducts = [
  {
    id: 1,
    type: "Coriander Seed ድንብላል",
    links: "#",
    description: 'Style scrambled egg with Tomato, onion, and green paper and other spices cooked together. served with enjere or bread served in your choice',
    price: 1.99,
    salesTax: 'Sales Tax Included',
    bestSeller: 200,
    pic: pic1,
    SKU: "MMC800663",
  },
  {
    id: 2,
    type: "Chick Pea Flour ምጥን ሽሮ",
    links: "#",
    description: 'Dried Beef in Berbere sauce and other spices mixed with Injera served on Ethiopian Injera( Flat Bread)',
    price: 15.99,
    salesTax: 'Sales Tax Included',
    bestSeller: 200,
    pic: pic2,
    SKU: "MMC800663",
  },
  {
    id: 3,
    type: "Stowed Barley በሶ",
    links: "#",
    description: 'Ethiopian bread እንጀራ mixed with onion tomatoes green pepper tossed in berbere (red pepper) sauce',
    price: 10.99,
    salesTax: 'Sales Tax Included',
    bestSeller: 150,
    pic: pic3,
    SKU: "MMC800663",

  },
  {
    id: 4,
    type: "Popcorn ፈንዲሻ",
    links: "#",
    description: 'Cracked wheat served with Ethiopian Metemeta and other spices',
    price: 6.99,
    salesTax: 'Sales Tax Included',
    bestSeller: 50,
    pic: pic4,
    SKU: "810120213408",
  },
  {
    id: 5,
    type: "Cloves ቅርንፉድ",
    links: "#",
    description: 'Specially cooked beans served mix with red onions, fresh green pepper, fresh ricotta cheese, fried egg and olive oil served with bread',
    price: 4.99,
    salesTax: 'Sales Tax Included',
    bestSeller: 800,
    pic: pic1,
    SKU: "810120210698",
  },
  {
    id: 6,
    type: "Dried cut Ginger root ዝንጅብል",
    links: "#",
    description: 'Scrambled egg with meat, tomato, onion, and green pepper and other spices cooked together, served with injera or bread',
    price: 3.99,
    salesTax: 'Sales Tax Included',
    bestSeller: 0,
    pic: pic2,
    SKU: "810120211152",
  },
  {
    id: 7,
    type: "Cinnamon Chips የተከካ ቀረፋ",
    links: "#",
    description: 'Roasted and powdered peas are simmered with red onion, vegetable oil, garlic, ginger, and spicy red pepper',
    price: .99,
    salesTax: 'Sales Tax Included',
    bestSeller: 10,
    pic: "#",
    SKU: "810120210629",
  },
  {
    id: 8,
    type: "Cardamom Pods ሄል አረንጓዴ",
    links: "#",
    description: 'Specially Cooked cave beans served mix with Red Onions, Fresh Green Paper, Fresh Ricotta Cheese, Boiled Egg and Olive Oil served with bread.',
    price: 5.99,
    salesTax: 'Sales Tax Included',
    bestSeller: 200,
    pic: "#",
    SKU: "810120210506",
  },
  {
    id: 9,
    type: "Ground Ginger የተፈጨ ዝንጅብል",
    links: "#",
    description: 'Specially mixed small pieces of fried flatbread, spiced with buttered powdered red pepper',
    price: 3.49,
    salesTax: 'Sales Tax Included',
    bestSeller: 1000,
    pic: "#",
    SKU: "810120211183",
  },
];



export const stateNames = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut',
  'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas',
  'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota',
  'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey',
  'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon',
  'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah',
  'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
];
